module.exports = __webpack_public_path__ + "img/404page.04475889.svg";